import { ReactComponent as AddCircle } from "./svg/add-circle.svg";
import { ReactComponent as RemoveCircle } from "./svg/remove-circle.svg";

export default {
  AddCircle,
  RemoveCircle
};
